<template>
  <div class="pt-toolbar">
    <h2
      v-if="title && !estructureSeotitle"
      :class="dense ? 'pt-toolbar__title-sm' : 'pt-toolbar__title'"
      v-text="title"
    />
    <span
      v-if="title && estructureSeotitle"
      :class="dense ? 'pt-toolbar__title-sm' : 'pt-toolbar__title'"
      v-text="title"
    />
    <NuxtLink v-if="link.url" :to="link.url" class="pt-toolbar__link">
      {{ link.label }}
      <Icon name="pt-arrow-right" class="text-xl" />
    </NuxtLink>
  </div>
</template>

<script>
export default {
  name: 'Toolbar',
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: () => ({})
    },
    dense: {
      type: Boolean,
      default: false
    },
    estructureSeotitle: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style src="./style.scss" lang="scss"></style>
